module.exports = __webpack_public_path__ + "static/media/mw.0b965195.svg";